import React from 'react';
import { Link } from 'react-router-dom';
import { CONTACT_INFO, COMPANY_INFO } from '../../utils/constants';
import './ServicePage.css';

const SevenTonTruck: React.FC = () => {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section className="service-hero">
        <div className="container">
          <div className="hero-content">
            <h1>7 Ton Pickup Truck Rental Dubai</h1>
            <p>Perfect for office moves, large deliveries, and heavy commercial transportation across Dubai</p>
            <div className="hero-buttons">
              <a href={`tel:${CONTACT_INFO.phone}`} className="btn-primary">Call Now: {CONTACT_INFO.phone}</a>
              <a href={`mailto:${CONTACT_INFO.email}`} className="btn-secondary">Get Quote</a>
            </div>
          </div>
          <div className="hero-image">
            <img src="/7-ton-pickup-rental-truck-dubai.png" alt="7 Ton Pickup Truck Dubai" />
          </div>
        </div>
      </section>

      {/* Service Details */}
      <section className="service-details">
        <div className="container">
          <div className="service-overview">
            <h2>7 Ton Pickup Truck Rental Service in Dubai</h2>
            <p>
              Our 7 ton pickup truck rental service in Dubai is designed for large-scale operations, 
              office relocations, and heavy commercial deliveries. With substantial capacity and 
              professional handling, we ensure efficient transportation of large loads across Dubai.
            </p>
          </div>

          <div className="service-features">
            <h3>Key Features of Our 7 Ton Pickup Trucks</h3>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">🚛</div>
                <h4>Heavy-Duty Tail Lift</h4>
                <p>Industrial-grade hydraulic tail lift for large and heavy items</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📦</div>
                <h4>Open & Box Options</h4>
                <p>Flexible cargo configurations for various large load types</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">⏰</div>
                <h4>24/7 Service</h4>
                <p>Round-the-clock availability for urgent large transportation needs</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">👨‍💼</div>
                <h4>Expert Driver</h4>
                <p>Professional drivers specialized in large load transportation</p>
              </div>
            </div>
          </div>

          <div className="service-applications">
            <h3>Perfect For</h3>
            <div className="applications-grid">
              <div className="application-item">
                <h4>🏢 Large Office Moves</h4>
                <p>Ideal for corporate relocations, office equipment, and large furniture</p>
              </div>
              <div className="application-item">
                <h4>🏭 Industrial Deliveries</h4>
                <p>Perfect for heavy machinery, industrial equipment, and large commercial goods</p>
              </div>
              <div className="application-item">
                <h4>🏗️ Construction Projects</h4>
                <p>Efficient for large building materials, heavy machinery, and construction supplies</p>
              </div>
              <div className="application-item">
                <h4>🚚 Commercial Logistics</h4>
                <p>Great for large-scale deliveries, warehouse operations, and commercial transportation</p>
              </div>
            </div>
          </div>

          <div className="service-areas">
            <h3>Service Areas in Dubai</h3>
            <p>We provide 7 ton pickup truck rental services across all major areas of Dubai:</p>
            <div className="areas-list">
              <div className="area-group">
                <h4>Central Dubai</h4>
                <p>Downtown Dubai, DIFC, Business Bay, Jumeirah, Marina, DSO</p>
              </div>
              <div className="area-group">
                <h4>Northern Emirates</h4>
                <p>Deira, Bur Dubai, Karama, Satwa, Al Quoz, Mirdif</p>
              </div>
              <div className="area-group">
                <h4>New Dubai</h4>
                <p>Dubai Hills, Dubai Sports City, JVC, JLT, Motor City, Arabian Ranches</p>
              </div>
              <div className="area-group">
                <h4>Industrial Areas</h4>
                <p>Al Quoz Industrial, Jebel Ali, DIP, DIC, DWC, Silicon Oasis</p>
              </div>
            </div>
          </div>

          <div className="pricing-info">
            <h3>Competitive Pricing</h3>
            <p>
              Our 7 ton pickup truck rental rates are competitive and transparent. We offer flexible 
              pricing options including hourly, daily, and weekly rentals. Contact us for a detailed 
              quote based on your specific requirements.
            </p>
            <div className="pricing-features">
              <div className="pricing-item">
                <span className="icon">✅</span>
                <span>No hidden charges</span>
              </div>
              <div className="pricing-item">
                <span className="icon">✅</span>
                <span>Fuel included</span>
              </div>
              <div className="pricing-item">
                <span className="icon">✅</span>
                <span>Driver included</span>
              </div>
              <div className="pricing-item">
                <span className="icon">✅</span>
                <span>Insurance covered</span>
              </div>
            </div>
          </div>

          <div className="booking-process">
            <h3>How to Book</h3>
            <div className="process-steps">
              <div className="step">
                <div className="step-number">1</div>
                <h4>Contact Us</h4>
                <p>Call or email us with your pickup and delivery details</p>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <h4>Get Quote</h4>
                <p>Receive a detailed quote with pricing and timing</p>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <h4>Confirm Booking</h4>
                <p>Confirm your booking and receive confirmation details</p>
              </div>
              <div className="step">
                <div className="step-number">4</div>
                <h4>Service Delivery</h4>
                <p>Our driver arrives on time with the 7 ton pickup truck</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Book Your 7 Ton Pickup Truck?</h2>
            <p>Contact us now for reliable and professional 7 ton pickup truck rental services in Dubai</p>
            <div className="cta-buttons">
              <a href={`tel:${CONTACT_INFO.phone}`} className="btn-primary">Call: {CONTACT_INFO.phone}</a>
              <a href={`mailto:${CONTACT_INFO.email}`} className="btn-secondary">Email Us</a>
            </div>
          </div>
        </div>
      </section>

      {/* Related Services */}
      <section className="related-services">
        <div className="container">
          <h3>Other Truck Rental Services</h3>
          <div className="services-grid">
            <Link to="/services/5-ton-truck" className="service-card">
              <img src="/pickup-rental-truck-dubai-home8_210x160.jpeg" alt="5 Ton Pickup Truck" />
              <h4>5 Ton Pickup Truck</h4>
              <p>Great for larger moves and heavy deliveries</p>
            </Link>
            <Link to="/services/10-ton-truck" className="service-card">
              <img src="/pickup-rental-truck-dubai-home8.jpeg" alt="10 Ton Pickup Truck" />
              <h4>10 Ton Pickup Truck</h4>
              <p>Heavy-duty truck for commercial moves</p>
            </Link>
            <Link to="/services/3-ton-truck" className="service-card">
              <img src="/pickup-rental-truck-dubai-home2_210x160.jpeg" alt="3 Ton Pickup Truck" />
              <h4>3 Ton Pickup Truck</h4>
              <p>Ideal for medium-sized moves and deliveries</p>
            </Link>
          </div>
        </div>
      </section>

      {/* Related Blog Posts */}
      <section className="related-blog-posts">
        <div className="container">
          <h3>Related Articles</h3>
          <div className="blog-posts-grid">
            <Link to="/pickup-truck-rental-guide-dubai" className="blog-post-card">
              <div className="blog-post-content">
                <h4>The Ultimate Guide to Pickup Truck Rental in Dubai</h4>
                <p>Complete guide to renting pickup trucks in Dubai. Learn about truck sizes, pricing, and requirements.</p>
                <span className="read-more">Read More →</span>
              </div>
            </Link>
            <Link to="/best-movers-packers-dubai-2025" className="blog-post-card">
              <div className="blog-post-content">
                <h4>Best Movers and Packers in Dubai 2025</h4>
                <p>Discover the top-rated movers and packers in Dubai offering professional home shifting services.</p>
                <span className="read-more">Read More →</span>
              </div>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default SevenTonTruck;
